<template>
  <div class="client-details">

    <portal to="sidebar-menu">

      <div>
        <card type="user" plain footer-classes="p-0" class="mb-0 px-2">
          <div class="d-flex flex-column">
            <div class="d-flex text-overflow align-items-center">
              <base-avatar :src="user.image" :user="user" :circle="false" size="sm" alt="User avatar"/>
              <div class="ml-2">
                <el-tooltip :content="`${user.given_name} ${user.family_name}`" placement="top-start">
                  <div class="font-weight-bold mb-0 text-overflow">{{user.given_name}} {{user.family_name}}</div>
                </el-tooltip>
                <div class="d-flex align-items-center text-overflow">
                  <i class="nc-icon nc-email-85"></i>&nbsp;
                  <el-tooltip :content="user.email" placement="top-start">
                    <div class="description">{{user.email}}</div>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <hr>
        </card>

        <nav-list :items="navigationItems"
                  @on-delete-click="deleteUser">
        </nav-list>

      </div>

    </portal>

    <div class="row">
      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import NavList from 'src/components/List/NavList';
  import UserService from "src/services/UserService";
  import SettingsService from 'src/services/SettingsService'

  export default {
    name: 'user-profile',
    components: {
      NavList,
      UserService
    },
    data() {
      return {
        error: null,
        deleteActive: false
      }
    },
    computed: {
      navigationItems () {
        return [
          {
            type: 'group',
            name: this.$t('generic.settings')
          },
          {
            routeName: 'profile_dashboard',
            name: this.$t('user.details.menu.overview')
          },
          {
            routeName: 'profile_edit',
            name: this.$t('user.details.menu.edit')
          },
          {
            routeName: 'profile_password',
            name: this.$t('user.details.menu.password')
          },
          {
            name: this.$t('generic.delete.title'),
            title: 'delete'
          }
        ]
      },
      ...mapState('user', {
        user: state => state.user.user
      })
    },
    methods: {
      async deleteUser() {
        let msg = this.$t('user.details.delete.confirm', {msg: this.user.given_name})
        await this.$confirm(msg);
        await UserService.delete(this.user.uuid);
      },
      async updateLanguage(lang) {
        try {
          await SettingsService.updateSettings({
            app_locale: lang
          })
          this.$notify({type: 'success', message: this.$t('settings.general.success')})
        } catch (e) {
          this.$notify({type: 'danger', message: this.$t('settings.general.error')})
        }
      },
    }
  }
</script>
<style lang="scss">
  .client-details {
    .client-image {
      width: 150px;
      height: 100%;
    }
  }
  .lang__wrapper .language-select {
    width: 100%;
  }
</style>
